module.exports = __webpack_public_path__ + "img/card_communication.4838fd82.png";